import { useParams } from "react-router-dom";
import AgentChat from "@/components/AgentChat";

export default function AssistantPage() {
  const { publicKey } = useParams();
  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-0 sm:p-6">
      <div className="w-full sm:max-w-2xl h-screen sm:h-[80vh] bg-white sm:rounded-2xl sm:soft-shadow-lg overflow-hidden">
        <AgentChat publicKey={publicKey} />
      </div>
    </div>
  );
}
